.formBox {
  display: flex;
  flex-direction: column;
}

.formLabel {
  margin-bottom: 8px;
}
